import { useMutation, useQueryClient } from '@tanstack/react-query'

import { useAddNotification } from 'hooks/useAddNotification'
import { matchingsToServer } from 'models/name-to-domain-model'
import { put } from 'utils/http'

// Success/failure is in the response body's `errors` array (not HTTP status), so resolve inside mutationFn and return a boolean; invalidate the search on success.
export const useCreateNameToDomainMappings = () => {
  const queryClient = useQueryClient()
  const addNotification = useAddNotification()

  return useMutation({
    mutationFn: async (mappings: any) => {
      try {
        const result: any = await put('/management/companies/name_to_domain', matchingsToServer(mappings))

        const errorMessage = result?.errors?.slice(-1).pop()
        if (errorMessage) {
          addNotification(`Error occurred when adding mappings: ${errorMessage}`, 'error')
          return false
        }

        addNotification('Successfully submitted new mappings', 'success')
        queryClient.invalidateQueries({ queryKey: ['nameToDomain'] })
        return true
      } catch {
        // put() throws on HTTP-level failures (403/500/network); surface these as notifications rather than failing silently.
        addNotification('Failed to submit new mappings', 'error')
        return false
      }
    },
  })
}
